module.exports = __webpack_public_path__ + "img/logo-change.65e6783a.png";